import {
  KnownProjectTeamMemberDtoStatus,
  KnownSendInvitationDtoStatus,
  ProjectTeamMemberDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { Replay } from '@mui/icons-material';
import { makeDefineActions } from '../../../../ui/components/pure/actions-button/actions-button.helpers';
import { ActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { Edit } from '../../../../ui/components/pure/icons/Edit.icon';
import { Suspend } from '../../../../ui/components/pure/icons/Suspend.icon';
import { Invite } from '../../../../ui/components/pure/icons/Invite.icon';
import { Permissions } from '../../../../core/permissions/permissions.typings';

export enum TeamMemberDetailsActions {
  EDIT_TEAM_MEMBER = 'EDIT_TEAM_MEMBER',
  SUSPEND_USER = 'SUSPEND_USER',
  ACTIVATE_USER = 'ACTIVATE_USER',
  STATUS_CHANGE_ERROR = 'STATUS_CHANGE_ERROR',
  STATUS_CHANGE_SUCCESS = 'STATUS_CHANGE_SUCCESS',
  RESEND_INVITE = 'RESEND_INVITE',
  RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS'
}

function teamMemberDetailsActionsPredicate(user?: ProjectTeamMemberDto) {
  return !!user;
}

function makeTeamMemberDetailsActions(projectID: string): ActionsButtonItem<TeamMemberDetailsActions>[] {
  return [
    {
      title: 'Edit member details or access level',
      Icon: Edit,
      action: TeamMemberDetailsActions.EDIT_TEAM_MEMBER,
      permission: {
        action: Permissions.projects.updateTeamMember,
        projectID
      }
    },
    {
      title: 'Resend invite',
      Icon: Invite,
      action: TeamMemberDetailsActions.RESEND_INVITE,
      permission: {
        action: Permissions.projects.inviteTeamMember,
        projectID
      }
    },
    {
      title: 'Suspend member',
      Icon: Suspend,
      action: TeamMemberDetailsActions.SUSPEND_USER,
      permission: {
        action: Permissions.projects.updateTeamMember,
        projectID
      }
    },
    {
      title: 'Re-activate member',
      Icon: Replay,
      action: TeamMemberDetailsActions.ACTIVATE_USER,
      permission: {
        action: Permissions.projects.updateTeamMember,
        projectID
      }
    }
  ];
}

function makeValidateAction(teamMember: ProjectTeamMemberDto) {
  return function validateAction(action: TeamMemberDetailsActions) {
    switch (action) {
      case TeamMemberDetailsActions.EDIT_TEAM_MEMBER:
        switch (teamMember.invitationStatus) {
          case KnownSendInvitationDtoStatus.Active:
            return false;
          default:
            return true;
        }
      case TeamMemberDetailsActions.SUSPEND_USER:
        switch (teamMember.status) {
          case KnownProjectTeamMemberDtoStatus.Active:
            return true;
          default:
            return false;
        }
      case TeamMemberDetailsActions.ACTIVATE_USER:
        switch (teamMember.status) {
          case KnownProjectTeamMemberDtoStatus.Suspended:
            return true;
          default:
            return false;
        }
      case TeamMemberDetailsActions.RESEND_INVITE:
        if (!teamMember.invitationID) {
          return false;
        }
        switch (teamMember.status) {
          case KnownProjectTeamMemberDtoStatus.Invited:
            return true;
          default:
            return false;
        }

      default:
        return true;
    }
  };
}

export function makeDefineTeamMemberDetailsActions({
  projectID,
  teamMember
}: {
  teamMember: ProjectTeamMemberDto;
  projectID: string;
}) {
  return makeDefineActions(
    makeTeamMemberDetailsActions(projectID),
    teamMemberDetailsActionsPredicate,
    makeValidateAction(teamMember)
  );
}
